import { useNavigate } from 'react-router-dom';

export function useLogout() {
  const navigate = useNavigate();
  return () => {
    // Limpar dados do usuário do localStorage
    localStorage.removeItem('usuario');
    // Redirecionar para a página de login
    navigate('/login');
  };
}
